import { useCurrentUserContext, useGetGlobalFiltersLimit, useGetViewsWritePermission } from '@cs-cms/state-management';
import { CpsGridView, EditingViewState } from '@cs-cms/types';
import { computeViewButtonStates } from '../viewButtonStatesUtils';

interface UseUserViewsButtonStatesParams {
  views: CpsGridView[];
  selectedView: number | null | undefined;
  selectedViewData: CpsGridView | undefined;
  editingViewState: EditingViewState;
  hasUnsavedChanges: boolean;
  privateViewsLimit: number | undefined;
}

export const useUserViewsButtonStates = ({
  views,
  selectedView,
  selectedViewData,
  editingViewState,
  hasUnsavedChanges,
  privateViewsLimit
}: UseUserViewsButtonStatesParams) => {
  const { selectedIndex } = useCurrentUserContext();
  const { data: globalFiltersLimit, isLoading: isGlobalFiltersLimitLoading } = useGetGlobalFiltersLimit(
    selectedIndex?.id
  );
  const { data: hasWritePermission, isLoading: isWritePermissionLoading } = useGetViewsWritePermission(
    selectedIndex?.id
  );

  return computeViewButtonStates({
    views,
    selectedView,
    selectedViewData,
    editingViewState,
    hasUnsavedChanges,
    privateViewsLimit,
    globalFiltersLimit,
    isGlobalFiltersLimitLoading,
    hasWritePermission,
    isWritePermissionLoading
  });
};
